<template>
  <div class="flex items-end gap-0.5 h-4" :title="`${rssi} dBm`">
    <div
      v-for="i in 5"
      :key="i"
      class="w-1 rounded-sm"
      :class="i <= bars ? activeClass : 'bg-gray-300 dark:bg-dark-3'"
      :style="{ height: `${20 + i * 16}%` }"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    rssi: number;
    thresholds?: [number, number];
  }>(),
  {
    thresholds: () => [-96, -103] as [number, number],
  }
);

const bars = computed(() => {
  const r = props.rssi;
  const [green, yellow] = props.thresholds;
  const range = green - yellow;
  if (r >= green) return 5;
  if (r >= green - range * 0.3) return 4;
  if (r >= yellow) return 3;
  if (r >= yellow - range) return 2;
  return 1;
});

const activeClass = computed(() => {
  const r = props.rssi;
  const [green, yellow] = props.thresholds;
  if (r >= green) return 'bg-green-500';
  if (r >= yellow) return 'bg-orange-400';
  return 'bg-red-500';
});
</script>
